import {
  TaxonomyTheme,
  TaxonomyDepartment,
  TaxonomyExpertise,
  TaxonomyLocation,
} from '../implementations';

const mappers = {
  themes: TaxonomyTheme,
  departments: TaxonomyDepartment,
  expertises: TaxonomyExpertise,
  locations: TaxonomyLocation,
};

export default mappers;
